import React, { Component } from 'react';
import { DISPATCH_ID } from '../libs/utils/Const';
import { connect } from 'react-redux';
import '../css/dataTables.css';
import $ from 'jquery';
import AreYouAgreeModal from './AreYouAgreeModal';


class PointEquivalencePointsCardModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeModalConfiguration = async () => {
        const { GetAllConfiguration } = this.props;
        await GetAllConfiguration()
        $('#pointEquivalencePointsCard').modal('hide');
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $('#pointEquivalencePointsCard').on('hide.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            PointsCardModel,
            change_Point_Value,
            activeShowAreYouAgreeModal_Point_Value,
            showAreYouAgreeModal_Point_Value,
            CloseShowAreYouAgreeModal_Point_Value,
            Update_Point_Value,
        } = this.props;

        return (

            <>
                <div className="modal fade bd-example-modal-md modal-open scroll"
                    id="pointEquivalencePointsCard"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true">

                    <div className="modal-dialog modal-md modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white"
                                style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">
                                    Configuración de Equivalencia de Puntos
                                </h4>
                                <button type="button" className="close" onClick={this.closeModalConfiguration} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">
                                        &times;
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Asignar valor de punto del monedero</span>
                                                            </div>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                id="txtPoint_Value"
                                                                autocomplete="on"
                                                                min="0.01"
                                                                max="10"
                                                                step="0.01"
                                                                onChange={change_Point_Value}
                                                                value={PointsCardModel.Point_Value ? PointsCardModel.Point_Value : ''} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModalConfiguration} >Cerrar</button>
                                <button type="button" className="btn botonCorrect text-black" onClick={activeShowAreYouAgreeModal_Point_Value} >Guardar Cambios</button>
                            </div>
                        </div>
                    </div>
                </div>
                {showAreYouAgreeModal_Point_Value &&
                    <AreYouAgreeModal
                        mensaje={'¿Estás seguro que deseas actualizar el valor por punto?'}
                        accept={Update_Point_Value}
                        cancel={CloseShowAreYouAgreeModal_Point_Value}
                    />
                }
            </>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PointEquivalencePointsCardModal);